import { Text } from "@kvix/ui";
import { CircularProgress, Fade, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FadeIn } from "../../../../partials/Transitions/SlideUp";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 999999999,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    [theme.breakpoints.down(900)]: {
      right: 0,
    },

    backgroundColor: "rgba(0, 0, 0, 0.5)",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

interface Props {
  visible: boolean;
  view: "live" | "broadcast" | "page";
}

const ReconnectText = styled(Text)`
  font-weight: 700;
  color: #fff;
  margin-top: 22px;
`;

export const LoadingOverlay: React.FC<Props> = (props) => {
  const { t, ready } = useTranslation("session");
  const classes = useStyles(props);

  if (!ready) {
    return null;
  }

  return (
    <FadeIn delay={100}>
      <Fade in={props.visible}>
        <div className={classes.root}>
          <CircularProgress size={60} color="primary" />
          {props.view !== "page" && (
            <ReconnectText>
              {props.view === "broadcast" && <>{t("broadcastReconnectText")}</>}
              {props.view === "live" && <>{t("liveReconnectText")}</>}
            </ReconnectText>
          )}
        </div>
      </Fade>
    </FadeIn>
  );
};
